import {ChangeDetectorRef, Component, ViewChild} from '@angular/core';
import {OptionsComponent} from '@modules/activities/core/shared-components/options/options.component';
import {Observable, of} from 'rxjs';
import {AnswerResultInterface} from '@modules/activities/core/models';
import {ActivatedRoute} from '@angular/router';
import {ActivitiesService} from '@modules/activities/core/activities.service';
import {LessonsService} from '@modules/activities/core/lessons/services/lessons.service';
import {CommunicationCenterService} from '@modules/communication-center';
import {LessonNavigationService} from '../../lesson-navigation.service';
import {ItemAnswerStateEnum} from '@modules/activities/core/models/item-answer-state.enum';
import {AnswerInterface} from '@modules/activities/core/models/answer.interface';
import {BaseActivityComponent, TIME_DELAY_BEFORE_SAVE, TIME_DISPLAYING_CORRECTION} from '@modules/activities/core/player-components/base-activity.component';
import {answerStatusEnum} from '@modules/activities/core/models/answer-status.enum';
import {LessonsConfigurationService} from '@modules/activities/core/lessons/services/lessons-configuration.service';
import {FullscreenService} from 'fuse-core/services/fullscreen.service';
import {shuffle} from 'shared/utils/array';
import {ContextualService} from '@modules/activities/core/services/contextual.service';
import {v4 as uuidv4} from 'uuid';
import {QcmActivityGranule} from '@modules/activities/core/models/activities/typologies/qcm-activity.granule';

@Component({
    selector: 'app-qcu',
    templateUrl: './qcu.component.html'
})

/**
 * !!! be carreful WhatIsMissingComponent is similar at qcu so it just extend this component
 * so if you change thing here check if there is no repercussion
 * on WhatIsMissingComponent !!!
 */
export class QcuComponent extends BaseActivityComponent<QcmActivityGranule> {
    @ViewChild(OptionsComponent, {static: true}) optionsComponent: OptionsComponent;

    // si this.displaySaveBtn === true, on attends une validation par clic sur un bouton "valider"
    // si this.displaySaveBtn === false, on attends une validation par clic sur une réponse ett donc passage automatique a l'activité suivante
    // this.displaySaveBtn sert aussi à savoir si on utilise des checkbox ou non (TODO: ce qui n'est pas top du tout et à modifier).
    public displaySaveBtn = false; // Boolean know if we display checkbox or button, data fetched from the api
    public isTwoColumns = false;
    public showSubInstruction: boolean;
    public title: string;
    public type = '';
    public isTTSReading: { id: string, value: boolean };
    private waitUntilCorrectionFinished: boolean;
    public uuid = '';

    constructor(
        protected activatedRoute: ActivatedRoute,
        protected activitiesService: ActivitiesService,
        public config: LessonsConfigurationService,
        public fullscreenService: FullscreenService,
        protected lessonsService: LessonsService,
        protected communicationCenter: CommunicationCenterService,
        protected contextualService: ContextualService,
        protected ref: ChangeDetectorRef,
        protected lessonNavigationService: LessonNavigationService
    ) {
        super(activatedRoute, activitiesService, lessonsService, communicationCenter, contextualService, lessonNavigationService);
    }

    protected setContentData(activityAttributes): void {
        this.uuid = uuidv4();
        this.waitUntilCorrectionFinished = false;
        this.showSubInstruction = this.activitiesService.settings.showSubInstruction;
        if (activityAttributes.reference.config) {
            this.isTwoColumns = activityAttributes.reference.config.doubleColumn !== 0;
            this.displaySaveBtn = activityAttributes.reference.config.displaySaveBtn === true;
        }
        this.referenceActivityGranule = activityAttributes.reference;
        try {
            this.type = activityAttributes.reference.config.type ? activityAttributes.reference.config.type : '';
        } catch (ex) {
        }
        this.instruction = this.referenceActivityGranule.instruction;
        this.instructionAudio = this.referenceActivityGranule.instructionAudio;
        this.wording = (this.preview && !this.activitiesService.settings['hiddenFieldActivityPreview'].find(field => field === 'wording'))
        || !this.preview ? this.referenceActivityGranule.wording : '';
        this.wordingAudio = (this.preview && !this.activitiesService.settings['hiddenFieldActivityPreview'].find(field => field === 'wordingAudio'))
        || !this.preview ? this.referenceActivityGranule.wordingAudio : '';
        this.setDefaultAnswersAvailable();
        if (!this.isActivityEmbedded) {
            this.loadUserSave();
        }
        if (this.displayForSummary) {
            this.seeAnswerSolution();
        }
        // disable validate button enable it only if answer is made and only if the flag
        // displaySaveBtn is true no information on the use case of displaySaveBtn the code is recent so i let
        // the old behaviour except for the case of true false with data formated like i had in the example
        if (this.displaySaveBtn && !!this.buttons.find(b => b.type === 'validate')) {
            this.buttons.find(b => b.type === 'validate').disable = true;
        }
    }


    /**
     * permet d'initialisé le tableau des réponses selectionnés
     * @param answers
     * @param resetSelectEd reset answer selected to false
     * @private
     */
    private setDefaultAnswersAvailable(): void {
        this.availableAnswers = shuffle(this.referenceActivityGranule.activity_content.answers.map((answer) => {
            return {
                id: answer.id,
                answer: answer.answer,
                image: answer.image,
                select: !!+answer.select,
                correct_answer: !!+answer.correct_answer,
                state: ItemAnswerStateEnum.pristine,
                feedback: answer.feedback ? answer.feedback : '',
                audio: answer.audio ? answer.audio : null
            };
        }));
    }

    protected reset(resetAllSubscribe: boolean = false, type = null): Observable<boolean> {
        this.waitUntilCorrectionFinished = false;
        if (this.displayForSummary && this.referenceActivityGranule) {
            this.seeAnswerSolution();
        }
        return super.reset(resetAllSubscribe, type);
    }

    protected setAnswer(): void {
        if (this.userSave?.get('userActivity')?.entitySave?.answers && !this.displayForSummary) {
            const answers = this.userSave.get('userActivity').entitySave.answers;
            this.availableAnswers.forEach((option: AnswerInterface, index: number) => {
                if (answers[index]) {
                    this.answersSelected = [answers[index]];
                }
            });
            if (!this.lessonsService.isTrainerSeeCorrection()) {
                this.checkAnswer();
                this.activitiesService.userAnswer.next(answers);
                this.testAnswer = true;
            }
        }
    }

    protected checkAnswer(): void {
        this.answerStatus = answerStatusEnum.missing;
        if (this.autoCorrection) {
            const answerResult: AnswerResultInterface = {
                id: +this.activity.id,
                state: ItemAnswerStateEnum.missing,
                isLast: undefined
            };
            this.answersSelected.forEach((option) => {
                if (option.correct_answer) {
                    option.state = ItemAnswerStateEnum.currentlyCorrect;
                    answerResult.state = ItemAnswerStateEnum.currentlyCorrect;
                } else {
                    option.state = ItemAnswerStateEnum.incorrect;
                    answerResult.state = ItemAnswerStateEnum.incorrect;
                }
            });
            answerResult.isLast = this.allAnswerCorrect();
            // TODO faire une meilleure animation angular
            {
                setTimeout(() => {
                    super.manageProgressBarEventToSend(answerResult);
                    this.answersSelected.filter(a => a.state === ItemAnswerStateEnum.incorrect).forEach(a => a.state = ItemAnswerStateEnum.pristine);
                    this.answersSelected.filter(a => a.state === ItemAnswerStateEnum.currentlyCorrect).forEach(a => a.state = ItemAnswerStateEnum.wasCorrect);
                    if (this.isActivityEmbedded) {
                        this.isActivityEmbeddedDone = true;
                        if (this.allAnswerCorrect()) {
                            super.setFeedBackFromApi(null, answerStatusEnum.correct);
                        } else {
                            super.setFeedBackFromApi(null, answerStatusEnum.wrong);
                        }
                    } else {
                        if (this.allAnswerCorrect()) {
                            setTimeout(() => {
                                this.doAction('next', ['save']);
                            }, TIME_DELAY_BEFORE_SAVE);
                        } else {
                            this.waitUntilCorrectionFinished = false;
                        }
                    }
                }, this.type === 'isWordSelecting'
                && answerResult.state === ItemAnswerStateEnum.currentlyCorrect || answerResult.state === ItemAnswerStateEnum.wasCorrect ? 0 : TIME_DISPLAYING_CORRECTION);
                // for selecting text version we don't want any animation for true answers
            }
        } else {
            this.waitUntilCorrectionFinished = false;
        }
        if (this.answersSelected.length) {
            this.answerStatus = this.answersSelected.find((option: AnswerInterface) =>
                option.correct_answer) ? answerStatusEnum.correct : answerStatusEnum.wrong;
        }
        if (this.lessonsService.isLessonTraining() && !this.lessonsService.isAtLeastTrainer()) {
            this.displayFeedback = (this.answerStatus === 3)
                && this.activitiesService.settings.displayFeedback;
        }
        this.activitiesService.isUserAnswerStatus
            .next({status: this.answerStatus, index: this.activityStepIndex});
    }

    /**
     * add class to parent with the current state of the answer correct not correct
     * to apply style to parent
     */
    public answerStateClass(): string {
        const notCorrect = this.answersSelected.find(a => a.state === ItemAnswerStateEnum.incorrect);
        const correct = this.answersSelected.find(a => a.state === ItemAnswerStateEnum.wasCorrect);
        if (!correct && !notCorrect) {
            return '';
        }
        if (notCorrect) {
            return 'not-correct';
        }
        if (correct) {
            return 'correct';
        }
    }

    /**
     * verifie à bien selectionné la/les bonne(s) réponse(s)
     * @private
     */
    private allAnswerCorrect(): boolean {
        return this.answersSelected.some((option: AnswerInterface) => option.correct_answer);
    }

    /**
     * get the grade calculated with answer correctly answered
     */
    protected getGrade(): { newGrade: number, oldGrade: number } {
        return {
            newGrade: this.answersSelected.filter((answer: AnswerInterface) => answer.correct_answer).length,
            oldGrade: this.userSave ?
                this.userSave.get('userActivity').entitySave.answers.filter((answer: AnswerInterface) => answer.correct_answer).length : 0
        };
    }

    /**
     * récupere dans la config de l'activité la mise en page et ajoute le nombre de réponse pour gérer l'affichage
     */
    public get columnClass(): string {
        const answersCounter: number =  this.availableAnswers.length;
        const answersCounterClass = ' answers-counting-'+ answersCounter;
        if (this.type === 'isWordSelecting' || this.type === 'isLetterSelecting') {
            return '' + ' ' + this.answerStateClass() + answersCounterClass;
        } else {
            return this.availableAnswers && answersCounter > 3 ? 'columns-2 '+ answersCounterClass : 'columns-1 '+ answersCounterClass;
        }
    }

    public validate(option: AnswerInterface): void {
        if (option) {
            this.answersSelected = [{
                id: option.id,
                answer: option.answer,
                image: option.image,
                select: true,
                correct_answer: option.correct_answer,
                state: ItemAnswerStateEnum.pristine,
                feedback: option.feedback,
                audio: option.audio
            }];
        }
        this.onOptionChange(true);
        // si option !== undefined, le call vient du clic pour selectionner la réponse "valider"
        // si option === undefined, le call vient du bouton "valider", ce qui veut dire que l'on lance la correction
        if (!option && this.autoCorrection && !this.waitUntilCorrectionFinished) {
            this.waitUntilCorrectionFinished = true;
            this.checkAnswer();
        }
    }

    public get valueChecked(): string {
        return this.answersSelected[0]?.answer || null;
    }

    public set valueChecked(value: string) {
        this.availableAnswers.forEach((item: AnswerInterface) => {
            if (value === item.answer) {
                this.answersSelected = [item];
            }
        });
    }

    public get isDisabledOptions(): boolean {
        if (this.isActivityEmbedded && this.isActivityEmbeddedDone) {
            return true;
        } else if (this.displaySaveBtn) {
            return this.answersSelected.some((answer) => answer.state === ItemAnswerStateEnum.wasCorrect || answer.state === ItemAnswerStateEnum.currentlyCorrect);
        } else {
            return this.displaySolution || // solution displayed
                this.testAnswer || // answer tested
                (this.answerSaved && this.lessonsService.isLessonEvaluation()) || // answer saved and assignment is assessment or homework
                this.lessonsService.isLessonCorrected(); // assignment exist and due date finished
        }
    }

    /**
     * sert aux css pour afficher l'état d'une reponse
     * TODO: on doit faire en sorte que les class css utilise le "state" d'une réponse cf: ItemAnswerInterface
     * pour permettre de retourner simplement le "state" qui sera la également la class css
     * @param option
     */
    public optionState(answer: AnswerInterface): string {
        const answerSelected = this.answersSelected?.find((item: AnswerInterface) => item.id === answer.id);
        if (answerSelected) {
            if (answerSelected.state === ItemAnswerStateEnum.pristine) {
                return 'selected';
            }
            return answerSelected.state;
        }
        return ItemAnswerStateEnum.pristine;
    }

    /**
     * create answer entered by the user.
     * no need to create answer because answer already exist.
     * method needed for save in baseActivityComponent
     * @protected
     */
    protected saveAnswer(): Observable<number[]> {
        return of(null);
    }

    protected reviewAnswer(): void {
        throw new Error('Method not implemented.');
    }

    protected seeAnswerSolution(): void {
        this.answersSelected = this.referenceActivityGranule.activity_content.answers
            .filter((answer) => !!+answer.correct_answer)
            .map((answer) => {
                return {
                    id: answer.id,
                    answer: answer.answer,
                    image: answer.image,
                    select: !!+answer.correct_answer,
                    correct_answer: !!+answer.correct_answer,
                    state: ItemAnswerStateEnum.wasCorrect,
                    feedback: answer.feedback ? answer.feedback : '',
                    audio: answer.audio ? answer.audio : null
                };
            });
        this.displaySolution = true;
    }

    /**
     * set if Text to Speach is currently reading or not
     * @param evt
     */
    public ttsReadingEvent(evt: { id: string, value: boolean }): void {
        this.isTTSReading = evt;
        this.ref.detectChanges();
    }

    protected getAttempts(): number {
        throw new Error('Method not implemented.');
    }

    /**
     * return the state of itemAnswer (in ngFor)
     * @param option: ItemAnswerInterface
     */
    public getStateAnswer(itemAnswer: AnswerInterface): string {
        const answerSelected = this.answersSelected.find((answer) => answer.id === itemAnswer.id);
        return answerSelected ? answerSelected.state + ' selected' : ItemAnswerStateEnum.pristine;
    }

    /**
     * know if answer contain IMG, (used to display answer img)
     */
    public get answerContainImg(): boolean {
        const regexp = /<img/gi;
        return this.availableAnswers.some((answer) =>
            (!!answer.image && answer.image !== '') || !!answer.answer &&  answer.answer.search(regexp) !== -1 );
    }
}

